/** Formats a phone number into (xxx) xxx-xxxx. */
export const formatPhoneNum = (phoneNum) => {
  if (!phoneNum) return '';
  // Remove all non-digit characters
  let digits = phoneNum.replace(/\D/g, '');
  if (digits.length == 11 && digits.startsWith('1')) {
    // Remove leading '1' if present
    digits = digits.slice(1);
  } else {
    return '';
  }
  // Format the digits into (xxx) xxx-xxxx
  const match = digits.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phoneNum; // Return original if it doesn't match expected format
};